var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.00043 12.9995L12.9999 6.99951L7.00043 0.999512","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13 6.99268L1 6.99268","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowIcon.defaultProps = {"width":"100%","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 14 14","fill":"none"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
